export default {
  Host: 'https://admin.tkbase.cc',
}
